'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.isNextWeek;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/isNextWeek.js
// module id = 313
// module chunks = 0